<template>
  <div class="row">
    <div class="col-md-12">
      <div id="filter-card" class="row py-3 px-4">
        <div class="col-lg-12 col-xl-12 px-0">
          <form @submit.prevent="filterResult()">
            <div class="row align-items-end py-0 my-0 mx-0" v-if="filters">
              <div class="col-xl-3 col-lg-2 col-md-2 col-sm-6">
                <custom-multi-select
                  :is-inline="false"
                  :item-per-row="1"
                  :model.sync="supplier_id"
                  :not-list="false"
                  :options="supplierList"
                  :title="$t('general_report.supplier') + ':'"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  :required="false"
                  input-max-width="200px"
                  input-width="100%"
                  name="order_supplier_id"
                ></custom-multi-select>
              </div>
              <div class="col-xl-3 col-lg-2 col-md-2 col-sm-6">
                <custom-multi-select
                  :is-inline="false"
                  :item-per-row="1"
                  :model.sync="company_id"
                  :not-list="false"
                  :options="customerOptions"
                  :title="$t('general_report.customer') + ':'"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  :required="false"
                  input-max-width="200px"
                  input-width="100%"
                  name="order_company_id"
                ></custom-multi-select>
              </div>
              <div class="col-xl-3 col-lg-2 col-md-2 col-sm-6">
                <custom-multi-select
                  :is-inline="false"
                  :item-per-row="1"
                  :model.sync="represantative_id"
                  :not-list="false"
                  :options="representativeList"
                  :title="$t('general_report.representative') + ':'"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  :required="false"
                  input-max-width="200px"
                  input-width="100%"
                  name="order_representative_id"
                  :isOpenMultiselect="true"
                ></custom-multi-select>
              </div>
              <div class="col-xl-3 col-lg-2 col-md-2 col-sm-6">
                <custom-multi-select
                  :is-inline="false"
                  :item-per-row="1"
                  :model.sync="report_user_id"
                  :multiple="true"
                  :options="reportUsers"
                  :title="$t('general_report.report_user') + ':'"
                  :showInvalid="false"
                  :hasBottomMargin="false"
                  :required="false"
                  input-max-width="200px"
                  input-width="100%"
                  name="order_id"
                ></custom-multi-select>
              </div>
              <div class="col-lg-4 col-md-6 my-lg-2 my-sm-0 row mx-0 px-0">
                <div class="col-lg-6 col-md-6 col-sm-12 my-2 my-md-0">
                  <date-filter
                    :helper-text="$t('general.start_date')"
                    :model.sync="filters.start_date"
                    name="start_time"
                    title="general.start_date"
                  >
                  </date-filter>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 my-2 my-md-0">
                  <date-filter
                    :helper-text="$t('general.end_date')"
                    :model.sync="filters.end_date"
                    name="end_date"
                    title="general.end_date"
                  >
                  </date-filter>
                </div>
              </div>
              <div
                class="col-xl-1 col-lg-1 col-md-1 col-sm-12 mt-3 px-1 d-flex align-items-center justify-content-end m-0 pr-0 row"
                style="margin: 0 !important"
              >
                <div class="col-12 pr-0">
                  <button
                    class="w-100 btn btn-sm btn-outline-primary rounded-full font-weight-bold py-1"
                    @click.prevent="filterResult()"
                  >
                    {{ $t("general.filter") }}
                  </button>
                </div>
                <div class="col-12 pr-0">
                  <button
                    class="w-100 btn btn-sm btn-outline-primary rounded-full font-weight-bold mt-2 py-1"
                    @click="resetFilters"
                  >
                    {{ $t("general.clear") }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div
          :class="[resizeChartValue == 'piechart' ? 'col-12' : 'col-6']"
          v-if="resizeChartValue != 'linechart'"
        >
          <dashboard-box :title="$t('report.endorsemet_report')">
            <template v-slot:preview>
              <second-quality-donut-chart-report
                :start-date.sync="filters.start_date"
                :end-date.sync="filters.end_date"
                :currency-rate-options="currencyRateOptions"
                :onClickButton="onClickButton"
                :filters.sync="tempFilters"
                @resizecard="resizeCard"
              ></second-quality-donut-chart-report>
            </template>
          </dashboard-box>
        </div>
        <div
          :class="[resizeChartValue == 'linechart' ? 'col-12' : 'col-6']"
          v-if="resizeChartValue != 'piechart'"
        >
          <dashboard-box :title="$t('report.endorsemet_report')">
            <template v-slot:preview>
              <second-quality-bar-chart-report
                :start-date.sync="filters.start_date"
                :end-date.sync="filters.end_date"
                :currency-rate-options="currencyRateOptions"
                :onClickButton="onClickButton"
                :filters.sync="tempFilters"
                @resizecard="resizeCard"
              ></second-quality-bar-chart-report>
            </template>
          </dashboard-box>
        </div>
      </div>

      <dashboard-box>
        <template v-slot:preview>
          <div @contextmenu.prevent="onContextMenu">
            <data-table
              :bordered="false"
              :borderless="true"
              :fields.sync="fields"
              :hover="false"
              :items="formattedReport"
              :no-border-collapse="true"
              :outlined="false"
              :striped="true"
              :disabled-infinite-loading="false"
              :infiniteId="infiniteId"
              :sticky-header="true"
              tableVariant="''"
              :page.sync="page"
              :perPage.sync="perPage"
              @hitBottom="onHitBottom"
              :sortBy.sync="order"
              :sortDesc.sync="sort"
              :responsive="true"
            ></data-table>
          </div>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";

// COMPONENTS
import DashboardBox from "@/assets/components/DashboardBox";
import DataTable from "@/assets/components/dataTable/DataTable";
import TopWaybillNav from "@/view/pages/waybill/layouts/index/TopWaybillNav";
import SecondWaybillNav from "@/view/pages/waybill/layouts/index/SecondWaybillNav";
import InputFilter from "@/assets/components/filters/InputFilter";
import SelectFilter from "@/assets/components/filters/SelectFilter";
import DateFilter from "@/assets/components/filters/DateFilter";
import CustomMultiSelect from "@/assets/components/inputs/CustomMultiSelect";
import SecondQualityBarChartReport from "./SecondQualityBarChartReport";
import SecondQualityDonutChartReport from "./SecondQualityDonutChartReport";

import {
  HANDLE_INFINITE_SCROLL,
  LOADING,
  SET_ITEMS,
  SET_LOADING,
  ITEMS,
  SET_FILTER,
  FILTER,
} from "@/core/services/store/report/secondQuantityReport.module";

import {
  GET_ITEMS,
  GET_ITEMS as REST_GET_ITEM,
} from "@/core/services/store/REST.module";
import {
  LARAVEL_DATE_FORMAT,
  MOMENT_SYSTEM_DATE_FORMAT,
} from "@/core/config/constant";
import * as _ from "lodash";
import ContextMenu from "@/assets/components/contextMenu/ContextMenu";
import {
  SECOND_QUALITY_REPORT_START_DATE_STORAGE_NAME,
  SECOND_QUALITY_REPORT_END_DATE_STORAGE_NAME,
} from "@/core/storage/storage-names";

export default {
  name: "SecondQualityReport",
  components: {
    SelectFilter,
    InputFilter,
    DataTable,
    DashboardBox,
    TopWaybillNav,
    SecondWaybillNav,
    DateFilter,
    CustomMultiSelect,
    ContextMenu,
    SecondQualityBarChartReport,
    SecondQualityDonutChartReport,
  },
  computed: {
    ...mapGetters({
      loading: LOADING,
      filter: FILTER,
      items: ITEMS,
    }),
    filters: {
      get: function () {
        return this.filter;
      },
      set: function (value) {
        this.setFilter(value);
      },
    },
    onClickResizeControl() {
      if (this.resizeBool != true) {
        return this.resize();
      } else {
        return;
      }
    },
    formattedReport() {
      if (
        !this.items ||
        this.items.data === null ||
        this.items.data === undefined
      )
        return [];
      let temp = [];

      this.items.data.forEach((item) => {
        let expense_detail = item.order_expense_detail;
        let total_cut = expense_detail ? 
            (expense_detail.order_expense_detail_target_totals==0  || expense_detail.order_expense_detail_target_totals== null)
              ? item.total_cut
              : expense_detail.order_expense_detail_target_totals
          : 0
        temp.push({
          order_number: item.order.order_number,
          color: expense_detail ? (expense_detail.order_size_and_color
            ? expense_detail.order_size_and_color.color_name 
            : "-") : '-',
          report_user: item.user? item.user.name : "-",
          slaughter_quantity: total_cut,
          loaded_quantity: item.loaded_quantity_supplier,
          sample_amount: {
            supplier_amount: item.sample_amount_supplier,
            manager_amount: item.sample_amount_manager,
          },
          part_return: {
            supplier_amount: item.part_return_supplier,
            manager_amount: item.part_return_manager,
          },
          second_quantity: {
            supplier_amount: item.second_quantity_supplier,
            manager_amount: item.second_quantity_manager,
          },
          total_supplier: item.total_supplier,
        });
      });
      return temp;
    },
  },
  data() {
    return {
      // Filters & pagination
      infiniteId: 1,
      sort: "desc",
      order: "id",
      resizeChartValue: null,
      customerOptions: [],
      search: null,
      onClickButton: false,
      paginate: [],
      page: 1,
      perPage: 25,
      startDate: moment().subtract(30, "d"),
      endDate: moment().add(1, "d"),
      reportListUrl: "api/report/quality-closing-report",
      currencyRateOptions: [],
      companies: [],
      supplierList: [],
      representativeList: [],
      reportUsers: [],
      totalData: [],
      tempFilters: {},
      fields: [
        {
          key: "order_number",
          label: this.$t("report.order_number"),
          sortable: true,
          class:
            "text-center border border-top-0 border-right-0 font-weight-bolder font-size-lg ",
        },
        {
          key: "color",
          label: this.$t("report.color"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
        {
          key: "report_user",
          label: this.$t("Oluşturan"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
        {
          key: "slaughter_quantity",
          label: this.$t("Kesim Adeti"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
        {
          key: "loaded_quantity",
          label: this.$t("Yüklenen Adet"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
        {
          key: "custom_sample_amount",
          label: this.$t("Numune(P/G)"),
          sortable: true,
          class:
            "text-center border border-top-0 border-right-0 font-size-lg p-0",
        },
        {
          key: "custom_part_return",
          label: this.$t("Parça İade(P/G)"),
          sortable: true,
          class:
            "text-center border border-top-0 border-right-0 font-size-lg  p-0",
        },
        {
          key: "custom_second_quantity",
          label: this.$t("İkinci Kalite(P/G)"),
          sortable: true,
          class:
            "text-center border border-top-0 border-right-0 font-size-lg  p-0",
        },
        {
          key: "total_supplier",
          label: this.$t("Toplam"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg",
        },
      ],
      report_user_id: [],
      supplier_id: [],
      represantative_id: [],
      company_id: [],
    };
  },
  methods: {
    resizeCard(val) {
      this.resizeChartValue = val;
    },
    ...mapMutations({
      setFilter: SET_FILTER,
    }),
    beforeFilterResult() {
      setTimeout(() => {
        this.filterResult();
      }, 100);
    },
    filterResult() {
      localStorage.setItem(
        SECOND_QUALITY_REPORT_START_DATE_STORAGE_NAME,
        moment(this.filters.start_date)
      );
      localStorage.setItem(
        SECOND_QUALITY_REPORT_END_DATE_STORAGE_NAME,
        moment(this.filters.end_date)
      );
      let self = this;
      this.page = 1;
      this.filters.page = 1;
      this.infiniteId++;
      this.onClickButton = true;
      this.onHitBottom();
    },
    onContextMenu(event) {
      event.preventDefault();
    },
    onHitBottom($state = null) {
      if (this.loading) {
        return;
      }
      let self = this;
      let filters = _.cloneDeep(this.filters);

      this.tempFilters = filters;
      this.$set(
        filters,
        "start_date",
        moment(this.filters.start_date).format(LARAVEL_DATE_FORMAT)
      );
      this.$set(
        filters,
        "end_date",
        moment(this.filters.end_date).format(LARAVEL_DATE_FORMAT)
      );

      this.$set(filters, "order", this.order);
      this.$set(filters, "sort", this.sort);
      if (this.report_user_id) {
        this.$set(
          filters,
          "report_user_id",
          JSON.stringify(this.report_user_id)
        );
      }
      if (this.supplier_id) {
        this.$set(filters, "supplier_id", JSON.stringify(this.supplier_id));
      }
      if (this.represantative_id) {
        this.$set(
          filters,
          "represantative_id",
          JSON.stringify(this.represantative_id)
        );
      }
      if (this.company_id) {
        this.$set(filters, "company_id", JSON.stringify(this.company_id));
      }

      self.$store
        .dispatch(HANDLE_INFINITE_SCROLL, {
          url: self.reportListUrl,
          filters: filters,
          $state: $state,
        })
        .then((result) => {
          this.onClickButton = false;
          if (result.status) {
            this.infiniteId++;
            if ($state) {
              $state.loaded();
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
        });
    },
    resetFilters() {
      (this.sort = "desc"),
        (this.order = "id"),
        this.setFilter({
          page: 1,
          order_id: [],
          per_page: 25,
          search: "",
          start_date: moment().subtract(30, "d").format(LARAVEL_DATE_FORMAT),
          end_date: moment().add(1, "d").format(LARAVEL_DATE_FORMAT),
        });
      this.report_user_id = [];
      this.supplier_id = [];
      this.represantative_id = [];
      this.company_id = [];
    },
    setup() {
      let self = this,
        promises = [];
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/companies",
        })
      );
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/currency-rate",
        })
      );
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/second-quality-report-users",
        })
      );
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/supplier-list",
        })
      );
      promises.push(
        this.$store.dispatch(GET_ITEMS, {
          url: "api/representative-list",
        })
      );

      Promise.all(promises).then((results) => {
        if (results[0].status) {
          self.customerOptions = self.convertArrayToObjectByKey(
            results[0].data,
            "id",
            "name"
          );
        }
        if (results[1].status) {
          self.currencyRateOptions = results[1].data.data;
        }
        if (results[2].status) {
          self.reportUsers = self.convertArrayToObjectByKey(
            results[2].data,
            "id",
            "name"
          );
        }
        if (results[3].status) {
          self.supplierList = self.convertArrayToObjectByKey(
            results[3].data,
            "id",
            "name"
          );
        }
        if (results[4].status) {
          self.representativeList = self.convertArrayToObjectByKey(
            results[4].data,
            "id",
            "user_name"
          );
        }
      });
    },
  },
  created() {
    this.$store.commit(SET_LOADING, false);
    this.$store.commit(SET_ITEMS, {});
  },
  mounted() {
    let self = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t("menu.endorsement_report") },
    ]);

    if (!this.isUserGranted("EscTable", ["viewAny"])) {
      return false;
    }

    if (!this.filter) {
      this.resetFilters();
    }

    this.filters.end_date = localStorage.hasOwnProperty(
      SECOND_QUALITY_REPORT_END_DATE_STORAGE_NAME
    )
      ? moment(
          localStorage.getItem(SECOND_QUALITY_REPORT_END_DATE_STORAGE_NAME)
        )
      : moment().add(1, "d").format(LARAVEL_DATE_FORMAT);

    this.filters.start_date = localStorage.hasOwnProperty(
      SECOND_QUALITY_REPORT_START_DATE_STORAGE_NAME
    )
      ? moment(
          localStorage.getItem(SECOND_QUALITY_REPORT_START_DATE_STORAGE_NAME)
        )
      : moment().subtract(30, "d").format(LARAVEL_DATE_FORMAT);

    this.setup();
    this.onClickButton = true;
    setTimeout(this.filterResult, 500);
  },
  watch: {
    sort() {
      this.beforeFilterResult();
    },
    order() {
      this.beforeFilterResult();
    },
  },
};
</script>

<style>
*:focus {
  outline: none;
}

#dashboard-card-body {
  padding-bottom: 5px !important;
}

.info-total-area {
  margin-bottom: 1%;
  margin-right: -1%;
  padding-right: 5%;
}
.info-total-area > div {
  flex: 0 0 17%; /* Kutuların genişliğini ayarlamak için istediğiniz değeri kullanabilirsiniz */
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  background-color: white;
  font-weight: 600;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.general-area {
  margin-bottom: 1%;
  padding-left: 2%;
}
.general-area > div {
  flex: 1; /* Kutuların genişliğini ayarlamak için istediğiniz değeri kullanabilirsiniz */
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  padding: 10px;
  border-radius: 5px;
  background-color: white;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.total-area-text {
  font-size: 13px;
  font-weight: 400;
}
</style>
<style lang="scss">
.b-table-sticky-header > .table.b-table > thead > tr > th {
  background-color: white !important;
}
.b-table-sticky-header {
  max-height: 500px;
}
.b-table-sticky-header > .table.b-table > tbody > tr > th {
  background-color: white !important;
}
</style>
